module.exports = __webpack_public_path__ + "img/verified-tick.07c92a30.svg";